package com.iptvplayer.shared.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class SeriesEntity(
  public val id: String,
  public val sourceId: String,
  public val seriesId: Long,
  public val name: String,
  public val posterUrl: String?,
  public val plot: String?,
  public val castMembers: String?,
  public val director: String?,
  public val genre: String?,
  public val releaseDate: String?,
  public val rating: Double?,
  public val groupName: String?,
)
